import styled from '@emotion/styled'

export const AddOrganizationButtonWrapper = styled.div``
